/** API Feed Data: read-only view of every lot the upstream feeds sent (pdn_inbox), and Lotgen PDN. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { FEED_STATUSES, FEED_TABS } from "@/features/masters/api-feed-api";
import {
  ApiFeedPage,
  type ApiFeedSearch,
} from "@/features/masters/components/api-feed-page";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const search = z.object({
  source: z.enum(FEED_TABS).optional().catch(undefined),
  status: z.enum(FEED_STATUSES).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/masters/api-feed")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("pdn_inbox.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onSearch = useCallback(
    (next: Partial<ApiFeedSearch>) =>
      void navigate({ search: (prev) => ({ ...prev, ...next }) }),
    [navigate]
  );
  return <ApiFeedPage search={s} onSearch={onSearch} />;
}
